import { LoanData, LoanDetailsData, AutopayDetails } from '@/interfaces/loan';

export function getLoanData(state: LoanData): LoanDetailsData {
  return state.data;
}

export function hasLoanData(state: LoanData): boolean {
  return Object.keys(state.data).length > 0;
}

export function getDueDate(state: LoanData): string {
  return state.data.loan_details?.due_date ?? '';
}

export function getLender(state: LoanData): string {
  return state.data.lender;
}

export function getAutopayDetails(state: LoanData)
  : AutopayDetails | null {
  return state.autopayDetail;
}
